module.exports = __webpack_public_path__ + "static/zombie-52ce2ef7d2fee4916555ee8d673357ff.jpg";